import { cartUpdateErrorsMapping } from '../mappers/errors-mapping.js';

const getFlattenedCartFailureErrorCodes = (failureList)=>{
    let errorCodes = [];
    if (failureList && failureList.length) {
        errorCodes = failureList.reduce((pre, next)=>next.__typename ? [
                ...pre,
                cartUpdateErrorsMapping[next.__typename]
            ] : [
                ...pre
            ]
        , errorCodes);
    }
    return errorCodes;
};

export { getFlattenedCartFailureErrorCodes };
//# sourceMappingURL=get-flattened-cart-error-codes.js.map
